import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChevronDown = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.478 7.462a.75.75 0 0 1 1.06.016L12 16.206l8.462-8.728a.75.75 0 1 1 1.076 1.044L13.03 17.3a1.41 1.41 0 0 1-1.03.451 1.4 1.4 0 0 1-1.03-.451L2.462 8.522a.75.75 0 0 1 .016-1.06"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChevronDown;
